module.exports = __webpack_public_path__ + "static/media/core-values.56cfd818.svg";